import { render } from "./HeroiconsSolidLogin.vue?vue&type=template&id=46609b8d"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLogin.vue"]])

export default __exports__